import { Card, CardContent } from "@/components/ui/card";

export function Metric({ title, value }: { title: string; value: number | string }) {
  return (
    <Card>
      <CardContent className="p-5">
        <div className="text-sm text-muted-foreground">{title}</div>
        <div className="mt-2 text-3xl font-semibold tabular-nums">{value}</div>
      </CardContent>
    </Card>
  );
}

